import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AlarmsComponent } from '../alarms/alarms.component';
import { AlarmsqueryService } from '../service/alarmsquery.service';

@Component({
  selector: 'app-planillas',
  templateUrl: './planillas.component.html',
  styleUrls: ['./planillas.component.css']
})
export class PlanillasComponent implements OnInit {
  zoomLevel = 1;
  src = '' 
  public Places = ['Sierra/Quito/LaY', 'Costa/Machala/SucursalMachala', 'Costa/Guayaquil/Sonesta', 'Costa/Guayaquil/Urdesa'];
  public placesControl = new FormControl();
  public planillaControl = new FormControl();
  public planillas = [];

  constructor(private database: AlarmsqueryService) { }

  ngOnInit() {
    let list = this.database.listPlanillas().subscribe(result =>{
      let resultados: any = result;
      this.Places = [];
      for(let s in resultados)
      {
        this.Places.push(s);
      }
      
    })
  }

  change(){
    this.delay(100).then(any =>{
      let seleccion = this.placesControl.value;
      let sub = this.database.listPlanillas().subscribe(result =>{
        this.planillas = [];
        for(let s in result[seleccion])
        {
          this.planillas.push(result[seleccion][s]);
        }
        sub.unsubscribe();
        this.src = '';
        this.planillaControl.setValue(this.planillas[this.planillas.length - 1])
        this.src = this.planillas[this.planillas.length - 1].link
      })
    })
  }

  changePlanilla(){
    this.delay(100).then(any =>{
      let seleccion = this.planillaControl.value;
      this.src = seleccion.link;
    })
  }

  
  increaseZoom(){
    this.zoomLevel += 0.1;
  }
  
  decreaseZoom(){
    this.zoomLevel -= 0.1;
  }

  //delay
  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=>console.log("delay ", ms));
  }


}
